import {
  FormControl,
  MenuItem,
  Paper,
  Select,
  Theme,
  Typography,
  withStyles
} from '@material-ui/core'
import { CSSProperties, Fragment, useState } from 'react'
import {
  changeLanguageWithEvent,
  getCurrentLanguage
} from '../../translations/i18n'
import { MuiClasses } from '../../types'

const languages = [
  {
    label: 'FIN',
    value: 'fi'
  },
  {
    label: 'ENG',
    value: 'en'
  }
]

const styles = ({ breakpoints }: Theme) => ({
  container: {
    top: '20px',
    right: '15px',
    zIndex: 1202,
    position: 'absolute' as const,
    marginLeft: 'auto',
    transform: 'none',
    [breakpoints.down('sm')]: {
      marginLeft: 0,
      marginBottom: 0,
      right: '5px',
      textAlign: 'center' as const
    },
    '@media (max-width:300px)': {
      right: '3px'
    }
  },
  font: {
    [breakpoints.down('md')]: {
      display: 'none'
    }
  },
  languageForm: {
    alignItems: 'center' as any,
    [breakpoints.up('md')]: {
      position: 'relative' as any,
      width: 80,
      textAlign: 'center' as any
    },
    '& svg': {
      color: '#fff'
    },
  }
})

const renderLanguage = (language: string, isMobile?: boolean) => (
  <Fragment>
    {isMobile ? <Typography variant='body1'>{language}</Typography> : language}
  </Fragment>
)

interface ChangeLanguageFormProps {
  classes: MuiClasses
  mobile?: boolean
  go?: (language: string) => void
  style?: CSSProperties
}
const ChangeLanguageForm = ({
  classes,
  mobile,
  go,
  style,
}: ChangeLanguageFormProps) => {
  const [language, setLanguage] = useState<string>(getCurrentLanguage());
  const handleSetLanguage = (event: any) => {
    changeLanguageWithEvent(event);
    setLanguage(event.target.value);
    go && go(event.target.value);
  };

  const StyledPaper = withStyles({
    root: {
      backgroundColor: '#94004A',
      color: '#fff',
    },
  })(Paper);

  return (
    <StyledPaper
      square
      elevation={0}
      className={classes.container}
      style={style}
    >
      <FormControl className={classes.languageForm}>
        <Select
          style={{ color: '#fff', zIndex: 1203 }}
          disableUnderline
          onChange={handleSetLanguage}
          value={language}
          inputProps={{
            name: 'lang',
            id: 'lang',
          }}
        >
          {languages.map(({ value, label }) => (
            <MenuItem key={value} value={value}>
              {renderLanguage(label, mobile)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </StyledPaper>
  );
};

export default withStyles(styles)(ChangeLanguageForm);
